<script>
    import TagContainer from '@/components/base-components/TagContainer.vue';
    import { tagAddInList, tagRemoveInList } from '@/scripts/tag.js';

    export default {
        data() {
            return {
                tagValue: '',
            }
        },
        props: {
            data: Object,
            updateData: Function,
        },
        components: {
            TagContainer: TagContainer,
        },
        methods: {
            async addTag() {
                const newTagList = await tagAddInList(this.data['tags'], this.tagValue);
                this.updateData(newTagList, 'tags', false, true);
                this.tagValue = '';
            },
            async deleteTag(id) {
                const newTagList = await tagRemoveInList(this.data['tags'], id);
                this.updateData(newTagList, 'tags', false, true);
            },
        }
    }
</script>

<template>
    <div class="left_sub_panel_data">
        <label>Tag:</label>
        <div class="left_sub_multi_container mt_5 mb_10">
            <input 
                v-model="tagValue"
                type="text"
                class="right_input"
                list="tagList"
            >
            <button
                :disabled="tagValue === ''"
                @click="addTag"
                class="button_blue_100 ml_10"
            >Add</button>
        </div>

        <label
            v-if="data['tags'].length !== 0"
            class="mb_5"
        >Select Tag:</label>
        <div class="tag_container">
            <TagContainer 
                v-for="(tagValue, tagIndex) in data['tags']" :key="tagIndex"
                :tagID="tagValue"
                tagColor="tag"
                @deleteTag="deleteTag"
            />
        </div>
    </div>
</template>